import React, { useState } from "react";
import {
  Box,
  Button,
  Container,
  Heading,
  Text,
  VStack,
  Image,
  HStack,
  useToast,
  Spinner,
} from "@chakra-ui/react";

const EbookPage = () => {
  const toast = useToast();
  const [loading, setLoading] = useState(false);

  // Helper to build API base with optional `/api`
  const API_BASE = process.env.REACT_APP_API_BASE_URL || "";
  const buildUrl = (p) => {
    const base = API_BASE.replace(/\/$/, "");
    return /\/api$/.test(base) ? `${base}${p}` : `${base}/api${p}`;
  };

  const handleBuy = async () => {
    setLoading(true);
    try {
      const origin = window.location.origin;

      const res = await fetch(buildUrl("/stripe/ebook/create-checkout-session"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include", // fine for logged-in users; ignored for guests
        body: JSON.stringify({
          product: "cpg_founder_playbook",
          success_url: `${origin}/checkout/success`,
          cancel_url: `${origin}/checkout/cancel`,
        }),
      });

      if (!res.ok) {
        const text = await res.text().catch(() => "");
        throw new Error(`HTTP ${res.status} ${text}`);
      }

      const { checkout_url } = await res.json();
      window.location.href = checkout_url; // Redirect to Stripe Checkout
    } catch (err) {
      console.error(err);
      toast({
        title: "Checkout error",
        description: "We couldn’t start checkout. Please try again.",
        status: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box bg="#F7F5EB" color="#0E2721" minH="100vh" py={20}>
      <Container maxW="3xl">
        <VStack spacing={8} textAlign="center">
          <Heading size="2xl" color="#1C4C3F">
            The CPG Founder Playbook
          </Heading>

          <Image
            src="/images/ebook-cover.png"
            alt="The CPG Founder Playbook cover"
            borderRadius="xl"
            boxShadow="lg"
            maxW="sm"
            mx="auto"
          />

          <Text fontSize="lg" maxW="2xl" opacity={0.9}>
            Get practical, founder-to-founder strategies on launching and
            scaling in CPG—without the fluff.
          </Text>

          <HStack spacing={4} justify="center">
            <Button
              onClick={handleBuy}
              bg="#1C4C3F"
              color="white"
              _hover={{ opacity: 0.9 }}
              size="lg"
              isDisabled={loading}
            >
              {loading ? (
                <>
                  <Spinner size="sm" mr={2} /> Redirecting…
                </>
              ) : (
                "Buy Now"
              )}
            </Button>
          </HStack>

          <Text fontSize="sm" opacity={0.6}>
            Instant download after purchase. Secure checkout via Stripe.
          </Text>
        </VStack>
      </Container>
    </Box>
  );
};

export default EbookPage;
